import BitesApi, { COMMON_SERVICES_BASE_URL } from '..';

export const getSettings = (orgId: number) => BitesApi.get(`/organization/settings/${orgId}/`);
export const getPopularLocales = (orgId: number) =>
  BitesApi.get(`${COMMON_SERVICES_BASE_URL}/organization/${orgId}/popular_locales`);

export const updateUserDefaultOrganization = (user_organization_id: number, body: any) =>
  BitesApi.patch(`user_organization/${user_organization_id}/`, body);
